import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  UpdateStatus,
} from "../../../../../../../features/admin/website/home/who_we_are/slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const whoWeAre = useSelector((state) => state?.website?.who_we_are);

  console.log(whoWeAre, "whoWeAre");

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = whoWeAre?.current_page) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: whoWeAre?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(UpdateStatus(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    whoWeAre,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
